import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../redux/index";
import moneyFormat from '../functions/moneyFormat';
import { TableCell } from '@mui/material';

// pass row object as prop
const RebateBreakupRow = ({ row, count, tableHeader,stickyEnabled }) =>{
    // get redux persistant state from redux store 
    const transactionDetails = useSelector((state) => state.transactionDetails);
    const dispatch = useDispatch();
    const { setTransactionDetails } = bindActionCreators(actionCreators, dispatch);
    // event handler for link click to pass row data to transaction data
    const onClick = () => {
        let temp = row; 
        delete temp['producttypedescription']; 
        setTransactionDetails(temp);
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return( 
        <>
            {/* map logic over all columns in row object */}
            {tableHeader.map(el =>
                // apply moneyFormat to correct columns 
                el['columnname'] == 'netspend' || el['columnname'] == 'netinterchange' ?
                <> 
                    {row[el['columnname']] == null ?
                        <TableCell className={getRowClassName(el['columnorder'])} align='right'>None</TableCell>
                    :<TableCell className={getRowClassName(el['columnorder'])} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>}
                </>
                : el['columnname'] == 'blank' ?
                <TableCell className={getRowClassName(el['columnorder'])}> 
                    {/* link to transaction details page with event handler to pass props */}
                    <Link onClick={()=>onClick()}
                        to={{
                            pathname: "/TransactionDetailsPage",
                        }}
                        >
                        <button style={{color: process.env.REACT_APP_DARK_COLOR}} class='payout-table-button'>Details</button>
                    </Link>
                </TableCell>  
                // standard display for other cols
                :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>
            )}
            
        </>
    );
}

export default RebateBreakupRow;